/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import get from 'lodash/get';
import { useSnackbar } from 'notistack';
import T from 'i18n-react';
import { Box, Typography } from '@material-ui/core';
import {
  uploadFile,
  uploadFileReset,
  uploadMultipleFile,
  uploadMultipleFileReset,
} from 'shared/actions';
import Button, { ButtonColors } from 'components/Button';
import uploadImage from 'assets/img/upload.png';
import classes from './File.module.scss';

const BaseFile = (props) => {
  const { inputProps = {}, alwaysShowBtn, hideErrAfter3s, uploadDocument } = props;
  const {
    value,
    name,
    className,
    onChange,
    acceptTypes = [],
    maxMB = 500,
    largeFileSizeMessage = 'Your file must smaller than 500MB!',
    notAcceptTypeMessage = 'You can only upload correct file type!',
    isCallApi,
    isMultipleSelected,
    isDropzone = false,
    disabled,
    buttonProps: { btnText = T.translate('general.uploadAttachments'), ...otherButtonProps } = {},
    fileProps,
    errorText,
  } = inputProps;

  const [isLoading, setIsLoading] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const inputEl = useRef(null);
  const showSnackbarMessage = (message) => {
    enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
      },
    });
  };
  const beforeUploadImage = (file) => {
    const mime = file.type;
    const isLt500M = file.size / 1024 / 1024 < maxMB;
    if (!isLt500M) {
      showSnackbarMessage(largeFileSizeMessage);
      return isLt500M;
    }
    const isValid = acceptTypes.length > 0 ? acceptTypes.indexOf(mime) >= 0 : true;
    if (!isValid) {
      showSnackbarMessage(notAcceptTypeMessage);
      return isValid;
    }
    return isLt500M && isValid;
  };

  const onUploadFileApi = (file) => {
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    formData.append('file', file);
    setIsLoading(true);
    dispatch(
      uploadFile(new Date().getTime(), formData, (id, res) => {
        setIsLoading(false);
        onChange(res);
        uploadFileReset();
      }, null, true, uploadDocument)
    );
  };

  const onUploadMultipleFileApi = (files) => {
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < files.length; i++) {
      formData.append('file[]', files[i]);
    }

    setIsLoading(true);
    dispatch(
      uploadMultipleFile(new Date().getTime(), formData, (id, res) => {
        setIsLoading(false);
        onChange(res);
        uploadMultipleFileReset();
      }, null, uploadDocument)
    );
  };

  const handleFileUploaded = (file) => {
    if (!beforeUploadImage(file)) return;

    if (isCallApi) {
      onUploadFileApi(file);
    } else {
      onChange(file);
    }

    inputEl.current.value = '';
  };

  const handleMultipleFileUploaded = (files) => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < files.length; i++) {
      if (!beforeUploadImage(files[i])) {
        return;
      }
    }

    if (isCallApi) {
      onUploadMultipleFileApi(files);
    } else {
      onChange(files);
    }

    inputEl.current.value = '';
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    uploadMultiple: isMultipleSelected,
    accept: acceptTypes.toString(),
    onDrop: (files, fileRejections) => {
      if (fileRejections.length) setErrorStatus(true);
      else if (isMultipleSelected) handleMultipleFileUploaded(files);
      else handleFileUploaded(files?.[0]);
      if (!fileRejections.length) {
        setErrorStatus(false);
      }
    },
  });
  const [files, setFiles] = useState(acceptedFiles);

  useEffect(() => {
    if (errorStatus && hideErrAfter3s) {
      setTimeout(() => {
        setErrorStatus(false);
      }, 3000);
    }
  }, [errorStatus])
  

  return (
    <div className={clsx(classes.inputUploadFileWrapper, className)}>
      <input
        type='file'
        id={`${name}-upload-file`}
        name={name}
        ref={inputEl}
        className={classes.fileInput}
        onChange={(e) => {
          if (isMultipleSelected) {
            const files = get(e, 'target.files') || [];
            handleMultipleFileUploaded(files);
          } else {
            const file = (get(e, 'target.files') || [])[0];
            handleFileUploaded(file);
          }
        }}
        disabled={disabled}
        multiple={isMultipleSelected}
        accept={acceptTypes.length ? acceptTypes.toString() : '*'}
        {...fileProps}
      />
      {(value.length === 0 || isMultipleSelected || alwaysShowBtn)&&
        (isDropzone ? (
          <section className='container'>
            {(!files.length || isMultipleSelected) && (
              <Box
                display='flex'
                flexDirection='column'
                justifyContent='center'
                alignItems='center'
                height='155px'
                width='100%'
                style={{
                  border: '1px dashed #C4C8D0',
                  cursor: 'pointer',
                }}
                {...getRootProps()}>
                <input
                  {...getInputProps()}
                  id={`${name}-upload-file`}
                  name={name}
                  disabled={disabled}
                  multiple={isMultipleSelected}
                />
                <img src={uploadImage} alt='uploadImage' />
                <Box display='flex' justifyContent='center' alignItems='center'>
                  {btnText}
                </Box>
              </Box>
            )}
            {files.length > 0 && (
              <Box display='flex' flexDirection='column'>
                {files.map((file) => (
                  <Box key={file.path} display='flex' alignItems='center'>
                    <Typography
                      style={{
                        color: '#0C91C4',
                        textDecoration: 'underline',
                      }}>
                      {file.path}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}
          </section>
        ) : (
          <label
            htmlFor={`${name}-upload-file`}
            className={clsx(classes.componentWrapper, { [classes.disabled]: disabled })}>
            <Button
              buttonProps={{
                color: ButtonColors.PRIMARY,
                type: 'button',
                nonBackground: true,
                onClick: () => {
                  inputEl.current.click();
                },
                loading: isLoading,
                disabled,
                ...otherButtonProps,
              }}>
              {btnText}
            </Button>
          </label>
        ))}
      {(errorStatus || errorText) && (
        <Typography style={{ color: '#FF5555', fontSize: 12, marginTop: 12 }}>
          {errorText || T.translate('general.uploadedWrongType')}
        </Typography>
      )}
    </div>
  );
};

export default BaseFile;
